import { t } from '@lingui/macro'
import { Add as AddIcon } from '@mui/icons-material'
import { Box, Button } from '@mui/material'
import React, { useState } from 'react'
import { CreateCarePartnerModal } from './CreateCarePartnerModal'

interface CreateCarePartnerButtonProps {
    candidateId?: string
    onSuccess?: (carePartnerId: string) => void
    variant?: 'text' | 'outlined' | 'contained'
    size?: 'small' | 'medium' | 'large'
    disabled?: boolean
    children?: React.ReactNode
}

export const CreateCarePartnerButton: React.FC<CreateCarePartnerButtonProps> = ({
    candidateId,
    onSuccess,
    variant = 'outlined',
    size = 'medium',
    disabled = false,
    children = t`+ Create Care Partner`
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const handleOpenModal = () => {
        setIsModalOpen(true)
    }

    const handleCloseModal = () => {
        setIsModalOpen(false)
    }

    const handleSuccess = (carePartnerId: string) => {
        if (onSuccess) {
            onSuccess(carePartnerId)
        }
    }

    return (
        <Box>
            <Button
                variant={variant}
                size={size}
                startIcon={<AddIcon />}
                onClick={handleOpenModal}
                disabled={disabled}
                sx={{ minWidth: 120, height: 36 }}
            >
                {children}
            </Button>
            <CreateCarePartnerModal open={isModalOpen} onClose={handleCloseModal} onSuccess={handleSuccess} candidateId={candidateId} />
        </Box>
    )
}
